(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["voltura-finn-reviews"] && !Shopify.designMode) return;
  try {
    
  const initializeVolturaFinnReviews = (scope = document) => {
    scope.querySelectorAll('[data-voltura-finn-carousel]').forEach((carousel) => {
      if (carousel.dataset.initialized === 'true') return;

      const track = carousel.querySelector('[data-voltura-finn-track]');
      const previous = carousel.querySelector('[data-voltura-finn-previous]');
      const next = carousel.querySelector('[data-voltura-finn-next]');

      if (!track || !previous || !next) return;

      carousel.dataset.initialized = 'true';

      const cardWidth = () => {
        const card = track.querySelector('.voltura-finn-reviews__card');
        if (!card) return track.clientWidth;
        const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      };

      const update = () => {
        const end = track.scrollWidth - track.clientWidth - 2;
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= end;
      };

      previous.addEventListener('click', () => track.scrollBy({ left: -cardWidth(), behavior: 'smooth' }));
      next.addEventListener('click', () => track.scrollBy({ left: cardWidth(), behavior: 'smooth' }));
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeVolturaFinnReviews(), { once: true });
  } else {
    initializeVolturaFinnReviews();
  }

  document.addEventListener('shopify:section:load', (event) => initializeVolturaFinnReviews(event.target));

  } catch(e) { console.error(e); }
})();
})();
